// Collapsible reasoning section — brief planning/replanning narration (never the raw plan JSON,
// per the locked architecture decision — see `../useAgenticRunController.js`'s doc comment).
import React, {useState} from 'react';
import {Collapse, IconButton, Stack, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/** @param {{entries: Array<{id: string, message: string}>}} props */
const ReasoningSection = ({entries = []}) => {
    const [expanded, setExpanded] = useState(false);

    if (!entries.length) {
        return null;
    }

    return (
        <Stack spacing={0.5}>
            <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
                onClick={() => setExpanded((current) => !current)}
                sx={{cursor: 'pointer', userSelect: 'none', width: 'fit-content'}}
            >
                <IconButton
                    size="small"
                    aria-label={expanded ? 'Collapse reasoning' : 'Expand reasoning'}
                    sx={{transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s'}}
                >
                    <ExpandMoreIcon fontSize="small"/>
                </IconButton>
                <Typography variant="caption" color="text.secondary" sx={{fontWeight: 600}}>
                    Reasoning ({entries.length})
                </Typography>
            </Stack>
            <Collapse in={expanded} unmountOnExit>
                <Stack spacing={0.5} sx={{pl: 4, borderLeft: '2px solid', borderColor: 'divider', ml: 1.5}}>
                    {entries.map((entry) => (
                        <Typography key={entry.id} variant="caption" color="text.secondary">
                            {entry.message}
                        </Typography>
                    ))}
                </Stack>
            </Collapse>
        </Stack>
    );
};

export default ReasoningSection;
